<template>
<div :id="id" class="window window-view" :class="{'window-bg':option.bg}" status="false" @click.self.stop="hide">
	<div class="body bgContent bgView" :class="getSizeClass(size)">
		<Loading ref="Loading"></Loading>
		<div class="head bgContent">
			<div class="tool">
				<slot name="headButton"></slot>
				<button class="close bgClose style-close fSub hover-f-error" :title="$t('cmd153',['关闭'])" type="button" @click.stop="hide"><Icon name="close" class="close-ico" /></button>
			</div>
			<slot name="head"></slot>
		</div>
		<slot></slot>
	</div>
</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as lib from "@/util/lib.js";
import {getLanguageStr} from "@/util/language.js";

export default {
	name:'WindowForView',
	props:{
		id:{//指定dom的id
			type:String,
			default:""
		},
		bg:{//是否显示遮罩背景
			type:Boolean,
			default:false
		},
		size:{//设定大小
			type:String,
			default:"l"
		}
	},
	components:{Loading},
	created(){
	},
	data(){
		return {
			option:{
				bg:this.bg//是否显示背景
			},
		}
	},
	methods:{
		getLanguageStr,
		getTypeText:lib.getTypeText,
		getSizeClass:lib.getSizeClass,
		outClickToHide(e){
			if(e){
				// trace(e,true)
				if($(e.target).parents(".amap-sug-result").length==0){//处理编辑电站时，因高德地图的应用在外部生成了dom，此时不关闭
					this.hide();
				}
			}
		},
		loadStatusAction:function(action){
			if(action) this.$refs.Loading.show();
			else this.$refs.Loading.hide();
		},
		show:function(option){
			if(option){
				if(option.bg!=undefined) this.option.bg=option.bg;
			}
			setTimeout(()=>{//加延时保证平滑出现
				lib.windowCtrl($(this.$el),"true");
				if(option){
					if(option.end){
						setTimeout(option.end,500);
					}
				}
			},0);
			$(window).off("click",this.outClickToHide);
			$(window).on("click",this.outClickToHide);
		},
		hide:function(){
			$(window).off("click",this.outClickToHide);
			this.$emit('Close');
			lib.windowCtrl($(this.$el),"false",{end:()=>{
				this.$emit('Closed');
			}});
		}
	},
	watch:{
	},
	mounted(){
		if($(this.$el).parents(".window-view").length){//在详情内的固定使用背景遮罩
			this.option.bg=true;
		}
	}
}
</script>
<style lang="scss" scoped>
.window-view.window-bg{z-index:21;
	.body{top:0;}
}
.window-view .head>*{height:unset;}
.tool{position:absolute;right:1em;}
</style>




// WEBPACK FOOTER //
// src/components/common/ui/WindowForView.vue